import React from "react";
import styles from "./spinner.module.scss";

const cssClassName = "spinner";

const Spinner = () => {
  return (
    <div className={styles[cssClassName]}>
      <svg
        className="MuiCircularProgress-svg css-1idz92c-MuiCircularProgress-svg"
        viewBox="22 22 44 44"
      >
        <circle
          className="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate MuiCircularProgress-circleDisableShrink css-79nvmn-MuiCircularProgress-circle"
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.6"
          strokeDasharray="126.68"
          strokeDashoffset="37.9"
        ></circle>
      </svg>
    </div>
  );
};

export default Spinner;
